import { NEW, NEW_EDITION, NEW_EDITION_AVAILABLE, OFFER, SUPER_DEAL } from "../../common";
export var dealLabelTypes = new Set([NEW, NEW_EDITION, NEW_EDITION_AVAILABLE, OFFER, SUPER_DEAL]);
export var isDealLabel = function isDealLabel(label) {
  return (
    // Type casting used so that there can be type checking in DEAL_LABEL_TYPES and yet it can
    // be used for checking whether label has type DealLabelType.
    dealLabelTypes.has(label !== null && label !== void 0 ? label : '')
  );
};
//# sourceMappingURL=isDealLabel.js.map